import type React from 'react'
import { useState } from 'react'
import { type IResourceComponentsProps, useApiUrl, useNotification } from '@refinedev/core'
import { CustomSearchBar, filterData } from '../../components/shared/CustomSearchBar'
import { PhoneCommands } from '../../components/shared/PhoneCommands'

import {
  useTable,
  List,
  RefreshButton
} from '@refinedev/antd'

import { Popover, Table, Tag } from 'antd'

import {
  compareFn,
  convertSeconds,
  toColor,
  toData,
  toSec,
  getPhoneUpdateColor,
  getBalanceColor,
  getExpireColor,
  fetchWithAuth
} from '../../fn'

export const ConnectionsList: React.FC<IResourceComponentsProps> = () => {
  const { tableProps, tableQuery } = useTable({
    syncWithLocation: true,

    pagination: {
      mode: 'off'
    }
  })

  const { open } = useNotification()

  const API_URL = useApiUrl()

  const [query, setQuery] = useState<any>()
  const updatedTableProps = {
    ...tableProps,
    dataSource: filterData(tableProps.dataSource, query)
  }

  return (
    (
      <List
        headerButtons={
          <>
            {/* <Form layout="horizontal" {...tableProps}>
            <Form.Item name="q">
                <Input
                    placeholder="ID, Title, Content, etc."
                    prefix={<Icons.SearchOutlined />}
                />
            </Form.Item>
            <Form.Item>
                <Button htmlType="submit" type="primary">
                    Filter
                </Button>
            </Form.Item>
        </Form> */}
            <CustomSearchBar
              onFilter={setQuery}
            />
            <RefreshButton
              icon='💰'
              size='large'
              onClick={() => {
                fetchWithAuth(`${API_URL}/phone/registerCommand`, { method: 'POST', body: { instance: 'all', command: 'abracadabra-ussd-*131#' } })
                  .then((a) => {
                    console.log(a)
                    open?.({
                      type: 'success',
                      message: 'Richiesta inviata a tutti i telefoni',
                      description: 'Inviata richiesta di credito'
                    })
                  })
                  .catch(() => {
                    open?.({
                      type: 'error',
                      message: 'Errore',
                      description: 'Errore nella richiesta di credito'
                    })
                  })
              }}
            >
              Get Credit
            </RefreshButton>
            <RefreshButton
              icon='🌐'
              size='large'
              onClick={() => {
                fetchWithAuth(`${API_URL}/phone/registerCommand`, { method: 'POST', body: { instance: 'all', command: 'abracadabra-ussd-*137#' } })
                  .then((a) => {
                    console.log(a)
                    open?.({
                      type: 'success',
                      message: 'Richiesta inviata a tutti i telefoni',
                      description: 'Inviata richiesta dati'
                    })
                  })
                  .catch(() => {
                    open?.({
                      type: 'error',
                      message: 'Errore',
                      description: 'Errore nella richiesta dati'
                    })
                  })
              }}
            >
              Get Data
            </RefreshButton>
            <RefreshButton
              icon='🔊'
              size='large'
              onClick={() => {
                fetchWithAuth(`${API_URL}/phone/registerCommand`, { method: 'POST', body: { instance: 'all', command: 'abracadabra-volume-0' } })
                  .then((a) => {
                    console.log(a)
                    open?.({
                      type: 'success',
                      message: 'Richiesta inviata a tutti i telefoni',
                      description: 'Inviata comando per volume 0'
                    })
                  })
                  .catch(() => {
                    open?.({
                      type: 'error',
                      message: 'Errore',
                      description: 'Errore nel comando per volume 0'
                    })
                  })
              }}
            >
              Set volume 0
            </RefreshButton>
            <RefreshButton
              icon='⏰'
              size='large'
              onClick={() => {
                fetchWithAuth(`${API_URL}/phone/registerCommand`, { method: 'POST', body: { instance: 'all', command: 'abracadabra-wakeup' } })
                  .then((a) => {
                    console.log(a)
                    open?.({
                      type: 'success',
                      message: 'Richiesta inviata a tutti i telefoni',
                      description: 'Inviata comando per wakeup'
                    })
                  })
                  .catch(() => {
                    open?.({
                      type: 'error',
                      message: 'Errore',
                      description: 'Errore nel comando per wakeup'
                    })
                  })
              }}
            >
              Wake up
            </RefreshButton>
            <RefreshButton
              icon='🆑'
              size='large'
              onClick={() => {
                fetchWithAuth(`${API_URL}/phone/registerCommand`, { method: 'POST', body: { instance: 'all', command: 'abracadabra-clear' } })
                  .then((a) => {
                    console.log(a)
                    open?.({
                      type: 'success',
                      message: 'Richiesta inviata a tutti i telefoni',
                      description: 'Inviata comando per cancellazione log'
                    })
                  })
                  .catch(() => {
                    open?.({
                      type: 'error',
                      message: 'Errore',
                      description: 'Errore nel comando per cancellazione log'
                    })
                  })
              }}
            >
              Clear Log
            </RefreshButton>
            <RefreshButton
              icon='🆙'
              size='large'
              onClick={() => {
                fetchWithAuth(`${API_URL}/phone/registerCommand`, { method: 'POST', body: { instance: 'all', command: 'abracadabra-upgrade' } })
                  .then((a) => {
                    console.log(a)
                    open?.({
                      type: 'success',
                      message: 'Richiesta inviata a tutti i telefoni',
                      description: 'Inviata comando per upgrade'
                    })
                  })
                  .catch(() => {
                    open?.({
                      type: 'error',
                      message: 'Errore',
                      description: 'Errore nel comando per upgrade'
                    })
                  })
              }}
            >
              Upgrade
            </RefreshButton>
            <RefreshButton
              icon='🚀'
              size='large'
              onClick={() => {
                fetchWithAuth(`${API_URL}/adb/deploy-all`, { method: 'POST' })
                  .then((a) => {
                    console.log(a)
                    open?.({
                      type: 'success',
                      message: 'Deploy All',
                      description: 'Deploy agent command sent to all phones'
                    })
                  })
                  .catch(() => {
                    open?.({
                      type: 'error',
                      message: 'Error',
                      description: 'Failed to deploy agent to all phones'
                    })
                  })
              }}
            >
              Deploy All
            </RefreshButton>
            <RefreshButton
              onClick={() => { window.location.reload() }}
              // resourceNameOrRouteName='phones'
              size='large'
            />

          </>
        }
        title='📱 Connections'
      >
        <Table
          {...updatedTableProps}
          rowKey='id'
        >
          <Table.Column
            dataIndex='id'
            title='📶 ID'
            sorter={{ compare: compareFn('id') }}
          />

          <Table.Column
            dataIndex='number'
            title='📞 Number'
            render={(value: any, record: any) => {
              const ph = record?.phone
              return (
                <pre>
                  {ph?.countryCode} {ph?.phone}{' '}
                  <Tag color={ph?.source === 'ussd' ? 'green' : 'default'} style={{ fontSize: '10px' }}>
                    {ph?.source === 'ussd' ? 'SIM' : 'seed'}
                  </Tag>
                  <Popover
                    title='Numero letto dalla SIM (USSD *132#)'
                    content={
                      <div style={{ fontSize: '12px' }}>
                        <div>
                          {
                            ph?.updated
                              ? `letto ${convertSeconds(toSec(ph.updated))} ago (${toData(ph.updated)})`
                              : 'mai letto: valore di partenza dal vault'
                          }
                        </div>
                        {record?.ussdLast?.raw && (
                          <pre style={{ fontSize: '11px', whiteSpace: 'pre-wrap' }}>{record.ussdLast.raw}</pre>
                        )}
                      </div>
                    }
                  >
                    <div style={{ fontSize: '11px', color: ph?.updated ? 'green' : '#888' }}>
                      📲 {ph?.updated ? `${convertSeconds(toSec(ph.updated))} ago` : 'mai letto'}
                    </div>
                  </Popover>
                </pre>
              )
            }}
            sorter={{ compare: compareFn('phone', undefined, (a: any) => a?.phone?.phone) }}
          />

          <Table.Column
            dataIndex='tethering'
            title='🚦 Status'
            render={(value: any, record: any) => (
              <>
                <Popover
                  content={
                    <span style={{ color: value?.usbTether === '🔗' ? 'green' : value?.usbTether === '🔌' ? 'red' : 'black' }}>
                      {value?.usbTether === '🔗' ? '🔗 Cavo connesso e usb tether attivato' : value?.usbTether === '🔌' ? '🔌 Cavo sconnesso o usb tether disattivato' : 'Cavo non rilevato'}

                    </span>
                  }
                  title='🔗🔌 Connessione Cavo / USB Tether '
                >
                  <span style={{
                    padding: '5px',
                    background: value?.usbTether === '🔗' ? 'green' : value?.usbTether === '🔌' ? 'red' : 'black'
                  }}
                  >{value?.usbTether}
                  </span>
                </Popover>
                <Popover
                  content={
                    <span style={{
                      color: value?.success
                        ? toSec(value?.timestamp) < 180
                          ? 'green'
                          : 'black'
                        : 'red'
                    }}
                    >
                      {value?.success
                        ? toSec(value?.timestamp) < 180
                          ? `🖥 Conesso correttamente dal PC controllato ${toSec(value?.timestamp)} secondi fa`
                          : `🖥 Connessione al PC non verificata da oltre ${toSec(value?.timestamp)} secondi`
                        : `🖥 Problema di connessione dal PC controllato ${toSec(value?.timestamp)} secondi fa`}
                    </span>
                  }
                  title='🖥 Stato connessione al PC (NETNS) '
                >
                  <span style={{
                    padding: '5px',
                    background: value?.success
                      ? toSec(value?.timestamp) < 180
                        ? 'green'
                        : 'black'
                      : 'red'
                  }}
                  >🖥
                  </span>
                </Popover>
                <Popover
                  content={
                    <span style={{ color: record?.enabled === false ? 'gray' : toColor(record.lastSeen) }}>
                      ⏱
                      {
                        // eslint-disable-next-line multiline-ternary
                        (record.lastSeen || record.lastSeen === '0') ? (
                          <>
                            <b>
                              {convertSeconds(toSec(record.lastSeen))} ago
                            </b>
                            <div>{toData(record.lastSeen)}</div>
                          </>
                        )
                          : (<b>Never</b>)
                      }
                    </span>
                  }
                  title='⏱ Ultima esecuzione di Automate sul telefono'
                >
                  <span style={{
                    padding: '5px',
                    background: toColor(record.lastSeen)
                  }}
                  >⏱
                  </span>
                </Popover>
                <Popover
                  content={
                    <span style={{ color: value?.wifi === '📡' ? 'red' : value?.wifi === '📶' ? 'green' : 'black' }}>
                      {value?.wifi === '📡' ? '📡 Connesso tramite il wifi' : value?.wifi === '📶' ? '📶 Connesso tramite il 5G' : 'Metodo di connessione non rilevato'}
                    </span>
                  }
                  title='Metodo di connessione del telefono'
                >
                  <span style={{
                    padding: '5px',
                    background: value?.wifi === '📡' ? 'red' : value?.wifi === '📶' ? 'green' : 'black'
                  }}
                  >{value?.wifi}
                  </span>
                </Popover>
                {record?.role === 'automate' && (
                  <Popover
                    content={
                      <span style={{ color: record?.adbLastSeen ? toColor(record.adbLastSeen) : 'red' }}>
                        {!record?.adbLastSeen
                          ? 'ADB non rilevato'
                          : toSec(record.adbLastSeen) < 120
                            ? `ADB connesso (${toSec(record.adbLastSeen)}s fa)`
                            : `ADB non visto da ${toSec(record.adbLastSeen)}s`}
                      </span>
                    }
                    title='ADB Connection'
                  >
                    <Tag color={record?.adbLastSeen ? toColor(record.adbLastSeen) : 'red'} style={{ marginLeft: '4px' }}>ADB</Tag>
                  </Popover>
                )}
                {record?.wsConnected !== undefined && (
                  <Popover
                    content={
                      <span style={{ color: record?.wsConnected ? 'green' : 'red' }}>
                        {record?.wsConnected ? 'WebSocket agent connected' : 'WebSocket agent disconnected'}
                      </span>
                    }
                    title='WS Agent Connection'
                  >
                    <Tag color={record?.wsConnected ? 'green' : 'red'} style={{ marginLeft: '4px' }}>WS</Tag>
                  </Popover>
                )}
              </>
            )}
            sorter={{ compare: compareFn('tethering') }}
          />

          <Table.Column
            dataIndex='proxy'
            title='🔀 Proxy / IP'
            render={(proxy: any, record: any) => {
              const tethering = record?.tethering
              if (!proxy) {
                return (
                  <pre style={{ fontSize: '12px' }}>
                    {tethering?.wifi} {tethering?.ip || '—'}
                    {
                      // eslint-disable-next-line multiline-ternary
                      (tethering?.lastUpdatedIp || tethering?.lastUpdatedIp === '0') ? (
                        <div>⏱ <b>{convertSeconds(toSec(tethering?.lastUpdatedIp))} ago</b>
                          <div>{toData(tethering?.lastUpdatedIp)}</div>
                        </div>
                      )
                        : (<b>⏱ Never</b>)
                    }
                  </pre>
                )
              }
              const statusColor = proxy.status === 'online' ? 'green' : proxy.status === 'banned' ? 'purple' : 'red'
              const isBanned = proxy.status === 'banned'
              return (
                <div style={{ fontSize: '12px' }}>
                  <div><Tag color={statusColor}>{proxy.status}</Tag> <Tag color={isBanned ? 'red' : 'green'}>{isBanned ? 'BANNED' : 'CLEAN'}</Tag></div>
                  <div style={{ fontWeight: 'bold', fontSize: '13px' }}>{tethering?.wifi} {proxy.wanIp || '?'}</div>
                  {
                    // eslint-disable-next-line multiline-ternary
                    proxy.lastChange ? (
                      <div style={{ color: '#888' }}>⏱ <b>{convertSeconds(toSec(proxy.lastChange))} ago</b>
                        <div>{toData(proxy.lastChange)}</div>
                      </div>
                    )
                      : (<div style={{ color: '#888' }}>⏱ <b>Never</b></div>)
                  }
                  <div>🖥 attive: {proxy.activeConnections ?? 0}</div>
                  {proxy.clients?.length > 0 && proxy.clients.map((c: { instance: string, mode: string }) => (
                    <div key={c.instance}>
                      <a style={{ fontWeight: 'bold' }} href={`/status/show/${c.instance}`}>
                        {c.instance}
                      </a>
                      <Tag style={{ marginLeft: '4px', fontSize: '10px' }} color={c.mode === 'sticky' ? 'blue' : 'orange'}>{c.mode}</Tag>
                    </div>
                  ))}
                </div>
              )
            }}
          />

          <Table.Column
            dataIndex='credit'
            title='💶 Credit'
            render={(value: any, record: any) => (
              <Popover
                content={
                  <span>⏱
                    {
                    // eslint-disable-next-line multiline-ternary
                      (record.creditUpdated || record.creditUpdated === '0') ? (
                        <>
                          <b style={{ color: getPhoneUpdateColor(toSec(record.creditUpdated) / 24 / 60 / 60) }}>
                            {convertSeconds(toSec(record.creditUpdated))} ago
                          </b>
                          {/* //! FORSE È DA FIXARE L'ANNO DELLA DATA */}
                          <div style={{ color: getPhoneUpdateColor(toSec(record.creditUpdated) / 24 / 60 / 60) }}>{toData(record.creditUpdated)}</div>
                        </>
                      )
                        : (<b>Never</b>)
                    }

                  </span>
                }
                title='⏱ Credit Updated'
              >
                <span style={{ color: getPhoneUpdateColor(toSec(record.creditUpdated) / 24 / 60 / 60) }}>💶 {value}</span>
              </Popover>
            )}
            sorter={{ compare: compareFn('credit') }}
          />

          {/* <Table.Column
            dataIndex='creditUpdated'
            render={(value: any, record: any) => {
              const days = toSec(value) / 24 / 60 / 60
              const color = getPhoneUpdateColor(days)
              return (
                <span>⏱
                  {
                    // eslint-disable-next-line multiline-ternary
                    (value || value === '0') ? (
                      <>
                        <b style={{ color }}>
                          {convertSeconds(toSec(value))} ago
                        </b>
                        <div style={{ color }}>{toData(value)}</div>
                      </>
                    )
                      : (<b>Never</b>)
                  }

                </span>
              )
            }}
            title='⏱ Credit Updated'
            sorter={{ compare: compareFn('lastSeen') }}
          /> */}

          <Table.Column
            dataIndex='balance'
            title='🌐 balance'
            render={(value: string) => {
              const numericValueMB = parseInt(value?.replace(/[^\d.-]/g, ''))
              const numericValueGB = Math.floor(numericValueMB / 1024)
              const color = getBalanceColor(numericValueGB)
              return (
                <span style={{ color, fontWeight: 'bold' }}>
                  🌐 {value}
                </span>
              )
            }}
            sorter={{ compare: compareFn('balance') }}
          />

          <Table.Column
            dataIndex='expire'
            title='🕔 expire'
            render={(expire: string, { credit }: any) => {
              return (
                <>
                  <span style={{ color: getExpireColor(credit, expire), fontWeight: 'bold' }}>{expire}</span>
                </>
              )
            }}
            sorter={{ compare: compareFn('expire') }}
          />

          <Table.Column
            dataIndex='balanceUpdated'
            render={(value: any, element: any) => {
              const days = toSec(value) / 24 / 60 / 60
              const color = getPhoneUpdateColor(days)
              return (
                <span>⏱
                  {
                    // eslint-disable-next-line multiline-ternary
                    (value || value === '0') ? (
                      <>
                        <b style={{ color }}>
                          {convertSeconds(toSec(value))} ago
                        </b>
                        {/* //! FORSE È DA FIXARE L'ANNO DELLA DATA */}
                        <div style={{ color }}>{toData(value)}</div>
                      </>
                    )
                      : (<b>Never</b>)
                  }
                </span>
              )
            }}
            title='⏱ Balance Update'
            sorter={{ compare: compareFn('balanceUpdated') }}
          />

          <Table.Column
            dataIndex='id'
            title='🕹 Actions'
            render={(id: string, record: any) => (
              <PhoneCommands
                record={record}
                apiUrl={API_URL}
                open={open}
                onAfterCommand={(key: string) => {
                  // Il numero della SIM arriva entro ~10s: rileggo la tabella per mostrarlo
                  if (key === 'number') setTimeout(() => { void tableQuery.refetch?.() }, 15000)
                }}
              />
            )}
          />

        </Table>
      </List>
    )
  )
}
